import type { JSX } from 'react';
import type {
  ChartAssay,
  DiseaseBurdenFilters,
  IChartLaneLogScale,
  IDiseaseBurdenData,
  InformedMode,
} from '@/types/PatientDashboard/PatientTimeline.types';
import DiseaseBurdenLaneBody from './DiseaseBurdenLaneBody';
import Section from './Section';

interface IProps {
  data: IDiseaseBurdenData;
  filters: DiseaseBurdenFilters;
  hiddenAnalytes: Record<string, boolean>;
  isLoading: boolean;
  hasFailure: boolean;
  isOpen: boolean;
  onToggle: () => void;
  onToggleAssay: (analyte: string, assay: ChartAssay) => void;
  onSetMode: (analyte: string, assay: ChartAssay, mode: InformedMode) => void;
  onToggleVisibility: (analyte: string) => void;
  onRetry: () => void;
  scale: IChartLaneLogScale;
  xPct: (date: string) => number;
}

export default function DiseaseBurdenPanel({
  data,
  filters,
  hiddenAnalytes,
  isLoading,
  hasFailure,
  isOpen,
  onToggle,
  onToggleAssay,
  onSetMode,
  onToggleVisibility,
  onRetry,
  scale,
  xPct,
}: IProps): JSX.Element {
  return (
    <Section
      title="Disease burden"
      count={data.analytes.length}
      isLoading={isLoading}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <DiseaseBurdenLaneBody
        data={data}
        filters={filters}
        hiddenAnalytes={hiddenAnalytes}
        isLoading={isLoading}
        hasFailure={hasFailure}
        onToggleAssay={onToggleAssay}
        onSetMode={onSetMode}
        onToggleVisibility={onToggleVisibility}
        onRetry={onRetry}
        scale={scale}
        xPct={xPct}
      />
    </Section>
  );
}
